import { ReactElement } from 'react';
import { SkeletonBar } from './SkeletonBar';
import './Skeleton.css';

export interface SkeletonPanelProps {
  fields?: number;
  className?: string;
}

/**
 * A bordered section skeleton: a header bar over a list of label/value field
 * rows. Mirrors the PIM detail panels and card-detail accordions.
 */
export function SkeletonPanel({ fields = 4, className }: SkeletonPanelProps): ReactElement {
  const fieldKeys = Array.from({ length: fields }, (_, index) => `pim-skeleton-panel-field-${index}`);
  const rootClass = ['pim-skeleton-panel', className].filter(Boolean).join(' ');
  return (
    <div className={rootClass} aria-hidden="true">
      <div className="pim-skeleton-panel__header">
        <SkeletonBar width="45%" height={12} strong />
      </div>
      {fieldKeys.map((fieldKey) => (
        <div key={fieldKey} className="pim-skeleton-panel__field">
          <span className="pim-skeleton-panel__field-label">
            <SkeletonBar width="70%" height={10} />
          </span>
          <span className="pim-skeleton-panel__field-value">
            <SkeletonBar width="85%" height={10} />
          </span>
        </div>
      ))}
    </div>
  );
}

export default SkeletonPanel;
